import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { Pagination } from '../models/pagination';
import { Company } from '../models/company';
import { FilterCompaniesForm } from '../pages/Administration/Companies/FilterCompanies';

const baseUrl = '/company';

const createCompany = (payload: Company): Promise<AxiosResponse<Company>> =>
  axios.post<Company>(baseUrl, payload);

const getCompanyById = (id: number): Promise<AxiosResponse<Company>> =>
  axios.get(`${baseUrl}/${id}`);

const updateCompany = (company: Company): Promise<AxiosResponse<void>> =>
  axios.put<void>(baseUrl, company);

const getCompaniesAutocomplete = (
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Company[]>> =>
  axios.get<Company[]>(`${baseUrl}/list`, config);

const getCompanies = (
  data?: FilterCompaniesForm,
  config?: AxiosRequestConfig
): Promise<AxiosResponse<Pagination<Company>>> =>
  axios.post<Pagination<Company>>(`${baseUrl}/filter`, data, config);

const exportCompanies = (
  data?: FilterCompaniesForm
): Promise<AxiosResponse<string>> =>
  axios.post(`${baseUrl}/export`, data, { responseType: 'blob' });

const activateCompany = (body: {
  id: number;
  activate: boolean;
}): Promise<AxiosResponse<void>> =>
  axios.put<void>(`${baseUrl}/activate`, body);

export const companyServices = {
  getCompanies,
  getCompanyById,
  getCompaniesAutocomplete,
  createCompany,
  updateCompany,
  exportCompanies,
  activateCompany
};
